// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ContactProfileModal_avatar__3XsbQ","close":"ContactProfileModal_close__1QDg-"};